export default [
  {
    path: "/vendors",
    name: "vendors",
    meta: {
      title: "Vendors",
      authRequired: true,
      resource: 'Tenant',
      action: 'vs.vendor.vendors.view',
      application: 'vendor-application',
      breadcrumb: () => [
        { text: 't-vendor-management', to: null, class: 'text-dark' },
        { text: 't-vendors', to: null }
      ]
    },
    component: () => import("@/views/vendors/index.vue")
  },
  {
    path: "/vendors/:vendorItemUuid/configs",
    name: "vendor-configs",
    meta: {
      title: "Vendors Configs",
      authRequired: true,
      resource: 'Tenant',
      action: 'vs.vendor.configs.view',
      application: 'vendor-application',
      breadcrumb: () => [
        { text: 't-vendor-management', to: null, class: 'text-dark' },
        { text: 't-vendor-items', to: {name: 'vendor-items'}},
        { text: 't-configs', to: null }
      ]
    },
    component: () => import("@/views/vendorItems/vendorConfigs/index.vue")
  },
  {
    path: "/vendor-categories",
    name: "vendor-categories",
    meta: {
      title: "Vendor Categories",
      authRequired: true,
      resource: 'Tenant',
      action: 'vs.vendor.categories.view',
      application: 'vendor-application',
      breadcrumb: () => [
        { text: 't-vendor-management', to: null, class: 'text-dark' },
        { text: 't-vendor-categories', to: null }
      ]
    },
    component: () => import("@/views/vendorCategories/index.vue"),
  },
  {
    path: "/vendor-items",
    name: "vendor-items",
    meta: {
      title: "Vendor Items",
      authRequired: true,
      resource: 'Tenant',
      action: 'vs.vendor.items.view',
      application: 'vendor-application',
      breadcrumb: () => [
        { text: 't-vendor-management', to: null, class: 'text-dark' },
        { text: 't-vendor-items', to: null }
      ]
    },
    component: () => import("@/views/vendorItems/index.vue"),
  },
  {
    path: "/vendor-credentials",
    name: "vendor-credentials",
    meta: {
      title: "Vendor Credentials",
      authRequired: true,
      resource: 'Tenant',
      action: 'vs.vendor.credentials.view',
      application: 'vendor-application',
      breadcrumb: () => [
        { text: 't-vendor-management', to: null, class: 'text-dark' },
        { text: 't-vendor-credentials', to: null }
      ]
    },
    component: () => import("@/views/vendorCredentials/index.vue")
  },
  {
    path: "/vendor-credentials/:credentialId",
    name: "vendor.credentials.detail",
    meta: {
      title: "Vendor Credential Details",
      authRequired: true,
      resource: 'Tenant',
      action: 'vs.vendor.credentials.view',
      application: 'vendor-application',
      breadcrumb: () => [
        { text: 't-vendor-management', to: null, class: 'text-dark' },
        { text: 't-vendor-credentials', to: { name: 'vendor-credentials' } },
        { text: history.state?.credential_name || 't-details', to: null }
      ]
    },
    component: () => import("@/views/vendorCredentials/detail.vue")
  },
];